import { render } from "./TextBlockWithImage.vue?vue&type=template&id=15707cbd&scoped=true"
import script from "./TextBlockWithImage.vue?vue&type=script&lang=js"
export * from "./TextBlockWithImage.vue?vue&type=script&lang=js"

import "./TextBlockWithImage.vue?vue&type=style&index=0&id=15707cbd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15707cbd"]])

export default __exports__